export const FUNDED_TYPES = {
  FUNDED: 'N',
  FUNDED_NO_TAXES: 'S',
  FUNDED_SPECIAL_TAXES: 'E',
};

export const CQ_POTS = {
  PAYMENT_POT: {
    TYPE: 'POPT',
    DIRECT_DEBIT_ID: '9',
    CARD: '60',
    FUNDED: '61',
    FUNDED_NO_TAXES: '66',
    FUNDED_SPECIAL_TAXES: '73',
  },
  SHIPPING_POT: {
    TYPE: 'POShT',
    STORE_SHIPPING_ID: '4',
    HOME_SHIPPING_ID: '6',
    HAND_SHIPPING_ID: '2',
    WEB_APP: '82',
  },
  INSTALLATION_POT: {
    TYPE: 'POIT',
    INSTALLATION_ID: '56',
    AUTO_INSTALLATION_ID: '57',
    INSTALLATION_BY_CLIENT: '58',
  },
  COMMITMENT_POT: {
    TYPE: 'POC',
    "36_MONTHS": '97',
    "48_MONTHS": '76',
  },
};

export const CATEGORIES = {
  DECODER: "123",
}

export const CQ_ACTION_CODES = {
  NO_ACTION: '0',
  REGISTER: '1',
  UNSUBSCRIBE: '2',
  MODIFY: '3',
  MIGRATION: '11',
  UNSUBSCRIBE_DUE_TO_PORTABILITY: '12',
  KEEP: '13',
  PORTABILITY: '15',
  BUY: '34',
  ACTIVATE_LINE: '41',
  UPGRADE_INCLUDED_LINE: '42',
  CONFIGURATION_CHANGE: '106',
  UHD_WIFI: '206',
  INTERNAL_PORTABILITY: '222',
  HGU_WITHOUT_COST: '333',
  UHD_WITHOUT_COST: '348',
  CHANGE_EQUIPMENT: '423',
  EQUIPMENT_CHANGE_DUE_TO_DEPENDENT_OFFER: '427',
};

export const CQ_ACTION_NAME = {
  NO_ACTION: 'NO HACER NADA',
  REGISTER: 'ALTA',
  UNSUBSCRIBE: 'BAJA',
  MODIFY: 'MODIFICAR',
  MIGRATION: 'MIGRACION',
  UNSUBSCRIBE_DUE_TO_PORTABILITY: 'BAJA DEBIDO A PORTABILIDAD DONANTE',
  KEEP: 'MANTENER',
  PORTABILITY: 'PORTABILIDAD',
  ACTIVATE_LINE: 'ACTIVACIÓN LÍNEA INCLUIDA',
  UPGRADE_INCLUDED_LINE: 'MEJORA LÍNEA INCLUIDA',
  CONFIGURATION_CHANGE: 'CAMBIO DE CONFIGURACION',
  INTERNAL_PORTABILITY: 'PORTABILIDAD INTERNA (O2)',
};

export const CHARACTERISTICS = {
  SPEED: '13',
  MAIL_TV: '15',
  COLOR: '20',
  STORAGE: '21',
  NETFLIX: '43',
  SIM_TYPE: '45',
  MPA: '49',
};

export const CHARACTERISTIC_VALUES = {
  NETFLIX: {
    STANDARD: '268',
    PREMIUM: '269',
    STANDARD_ADS: '3544',
  },
  SIM_TYPES:{
    SIM: "345",
    E_SIM: "346"
  },
  SPEED: {
    "300MB": '134',
    "600MB": '219',
    "1GB": '580',
    "2GB": '3883',
    "10GB": '3884',
  }
};

export const CHARACTERISTIC_VALUES_NAMES = {
  "268": "Estándar",
  "269": "Premium",
  "3544": "Estándar con Anuncios",
  "2902": "Estándar",
  "2896": "Estándar con Anuncios",
  "2893": "Premium",
}

export const SHOPPING_CART = {
  RECURRING_CHARGES_GROUP_TITLE: 'CUOTA MENSUAL',
  ONE_TIME_CHARGES_GROUP_TITLE: 'Pago único en primera factura',
  OVERWRITED_PROMOTION_TEXT: 'Precio hasta',
  PROMOTED_CLAIM: 'Promoción',
};

export const TECHNOLOGY = {
  FIBER: '7',
};

export const NETFLIX_PO = "498";

export const OTT_PRODUCTS = ["498", "496", "3873"];

export const TEXT_TYPES_CODES = {
  ORDINARY: '1',
  ABBREVIATED: '2',
  SHORT: '3',
  EXPLANATORY: '4',
  BRIEF: '5',
  MEDIUM: '6',
  REGULAR_WITH_VALUE: '7',
  ADDITIONAL_SHORT: '8',
  SHORT_EXPLANATORY: '9',
  LEGALS_EXPLANATORY: '10',
};

export const CQ_ACTION_CHARACTERISTICS_ID = {
  ICC: '8',
};

export const IVA = 'IVA';